import styled, { css } from "styled-components";

export const ButtonWrapper = styled.div`
	align-items: center;
	display: flex;
	height: 30px;
	width: 100%;
	@media (min-width: 744px) {
		width: 200px;
	}
	@media (min-width: 1024px) {
		width: 240px;
	}

	@media (min-width: 1600px) {
		height: 40px;
		min-width: 300px;
	}

	.ant-radio-group {
		background: var(--main-explosive-gradient);
		border-radius: 25px;
		align-items: center;
		display: flex;
		width: 100%;
		height: 30px;
		@media (min-width: 744px) {
			width: 200px;
		}
		@media (min-width: 1024px) {
			width: 240px;
		}

		@media (min-width: 1600px) {
			height: 40px;
			width: 100%;
		}
		.radio-btn-disabled {
			pointer-events: none;
			opacity: 0.5;
			cursor: none;
		}

		.ant-radio-button-wrapper {
			cursor: pointer;
			display: flex;
			width: 100%;
			height: 30px;
			justify-content: center;
			align-items: center;

			@media (min-width: 1024px) {
				width: 120px;
			}

			@media (min-width: 1600px) {
				height: 40px;
				width: 150px;
			}

			.ant-radio-button {
				display: none;
			}

			&:last-of-type {
				border-top-right-radius: 25px;
				border-bottom-right-radius: 25px;
			}

			& > span:last-of-type {
				color: var(--secondary-text-color);
				text-align: center;
				font-size: 10px;
				font-weight: 400;
				letter-spacing: 0.3px;
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 5px;
				@media (min-width: 1024px) {
					font-size: 12px;
				}

				@media (min-width: 1600px) {
					font-size: 14px;
				}
			}
		}
		.ant-radio-button-wrapper-checked {
			display: flex;
			width: 100%;
			height: 40px;
			justify-content: center;
			align-items: center;
			border-radius: 25px;
			background: var(--main-gradient);
			@media (min-width: 1024px) {
				width: 120px;
			}

			@media (min-width: 1600px) {
				height: 50px;
				border-radius: 25px;
				width: 150px;
			}

			& > span:last-of-type {
				color: var(--Gray-00, #fff);
				text-align: center;
				font-size: 10px;
				font-weight: 400;
				letter-spacing: 0.3px;

				@media (min-width: 1024px) {
					font-size: 12px;
				}

				@media (min-width: 1600px) {
					font-size: 14px;
				}
			}
		}
	}

	${({ hasOpacity }) =>
		hasOpacity &&
		css`
			.ant-radio-group {
				background: var(--main-color-dark-opacity-03);
			}
		`}
`;
